import { useEffect } from "react";
import { useI18n } from "../i18n/I18nContext";

const SITE_URL = "https://plombtechreno.com";

const setMeta = (name, content, attr = "name") => {
    if (!content) return;
    let el = document.head.querySelector(`meta[${attr}="${name}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
};

const setLink = (rel, href, extra = {}) => {
    let selector = `link[rel="${rel}"]`;
    if (extra.hreflang) selector += `[hreflang="${extra.hreflang}"]`;
    let el = document.head.querySelector(selector);
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        if (extra.hreflang) el.setAttribute("hreflang", extra.hreflang);
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
};

/**
 * Sets <title>, description, OG, Twitter and canonical/hreflang per route.
 * @param {"home"|"services"|"about"|"contact"} pageKey
 * @param {string} path - route path, e.g. "/services"
 */
export const useDocumentMeta = (pageKey, path) => {
    const { lang, t } = useI18n();

    useEffect(() => {
        const page = t.meta[pageKey] || t.meta.home;
        const title = page.title;
        const description = page.description;
        const url = `${SITE_URL}${path}`;

        document.title = title;
        setMeta("description", description);
        setMeta("og:type", "website", "property");
        setMeta("og:title", title, "property");
        setMeta("og:description", description, "property");
        setMeta("og:url", url, "property");
        setMeta("og:site_name", t.meta.siteName, "property");
        setMeta("og:locale", lang === "fr" ? "fr_CA" : "en_CA", "property");
        setMeta("twitter:card", "summary_large_image");
        setMeta("twitter:title", title);
        setMeta("twitter:description", description);

        setLink("canonical", url);
        setLink("alternate", `${SITE_URL}${path}`, { hreflang: "en" });
        setLink("alternate", `${SITE_URL}${path}`, { hreflang: "fr-CA" });
        setLink("alternate", `${SITE_URL}${path}`, { hreflang: "x-default" });
    }, [pageKey, path, lang, t]);
};
